import { FormControl, MenuItem, Select, Typography } from "@mui/material";
import { useSearch } from "../../../hooks/seach/useSearch";
import { styles } from "./styles";

export default function Status() {
    const {
        status, setStatus,
        allStatuses
    } = useSearch();

    return (
        <>
            <Typography style={styles.labelInput}>
                Status dos itens exibidos:*
            </Typography>
            <FormControl variant="outlined" style={styles.formControl}>
                <Select
                    onChange={e => setStatus(e.target.value)}
                    value={status}
                    style={{ 'background': '#fff' }}
                >
                    <MenuItem value="Todos">Todos</MenuItem>
                    {
                        allStatuses.map((status) => (
                            <MenuItem key={status.id} value={status.name}>{status.name}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </>
    );
}